import * as React from "react";
import { ActivityDashboard } from "~/ui/ActivityDashboard";
import { Helmet } from "react-helmet";

export const Dashboard = () => {
  return (
    <>
      <Helmet>
        <title>My Activity</title>
      </Helmet>
      <ActivityDashboard />
    </>
  );
};
